import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-6 pb-12 mt-6 border-t-2 border-white">
      <div className="max-w-4xl mx-auto text-center px-4">
        <div className="flex justify-center mb-4">
          <img 
            src="/nerd-nation-logo.png" 
            alt="Nerd Nation" 
            className="h-16 w-16 object-contain"
            style={{ filter: 'none' }} loading="lazy" decoding="async"/>
        </div>
        <h3 className="text-2xl font-bold mb-2">Nerd Nation</h3>
        <p className="text-gray-400 text-sm mb-1">Incubated At</p>
        <p className="text-gray-300 mb-4">DEIS – JNTU Hyderabad, Telangana State, India</p>
        <p className="text-gray-400 mb-2">
          Contact us:{' '}
          <a href="mailto:support@nerdindians.com" className="text-blue-400 hover:underline">
            support@nerdindians.com
          </a>
        </p>
        <p className="text-gray-400 mb-6">
          Call us:{' '}
          <a href="tel:+917330698844" className="text-blue-400 hover:underline">
            +91-7330698844
          </a>
        </p>
        <div className="flex items-center justify-between sm:justify-center gap-2 sm:gap-4 mb-6 flex-wrap">
          <Link
            to="/terms-and-conditions"
            className="text-blue-400 hover:underline text-xs sm:text-sm"
          >
            Terms & Conditions
          </Link>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <Link
            to="/privacy"
            className="text-blue-400 hover:underline text-xs sm:text-sm"
          >
            Privacy Policy
          </Link>
          <span className="text-gray-600 hidden sm:inline">|</span>
          <Link
            to="/contact-us"
            className="text-blue-400 hover:underline text-xs sm:text-sm"
          >
            Contact Us
          </Link>
        </div>
        <p className="text-gray-500 text-xs mt-6">
          © {new Date().getFullYear()} Nerd Nation. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
